<template>
	<v-layout justify-center align-center>
		<v-flex md8 lg6>
			<form @submit.prevent="submit()">
				<v-card >
					<v-card-title>
							<div class="headline">{{ $lang('AUTH:UPDATE_PASSWORD:CARD_TITLE-TEXT') }}</div>
					</v-card-title>
					<v-divider></v-divider>
					<v-card-text>


							<v-text-field
							:label="$lang('AUTH:UPDATE_PASSWORD:INPUT_TEXT_PASSWORD-LABEL')"
							:hint="$lang('AUTH:UPDATE_PASSWORD:INPUT_TEXT_PASSWORD-HINT')"
							v-model="user.password"
							type="password"
							:error-messages="errors && errors.password ? errors.password : []"
							></v-text-field>

							<v-text-field
							:label="$lang('AUTH:UPDATE_PASSWORD:INPUT_TEXT_PASSWORD_NEW-LABEL')"
							:hint="$lang('AUTH:UPDATE_PASSWORD:INPUT_TEXT_PASSWORD_NEW-HINT')"
							v-model="user.password_new"
							type="password"
							:error-messages="errors && errors.password_new ? errors.password_new : []"
							></v-text-field>

              <v-text-field
							:label="$lang('AUTH:UPDATE_PASSWORD:INPUT_TEXT_PASSWORD_NEW_CONFIRM-LABEL')"
							:hint="$lang('AUTH:UPDATE_PASSWORD:INPUT_TEXT_PASSWORD_NEW_CONFIRM-HINT')"
							v-model="user.password_new_confirm"
							type="password"
							:error-messages="errors && errors.password_new_confirm ? errors.password_new_confirm : []"
							></v-text-field>

					</v-card-text>
					<v-card-actions>
						<div class="text-xs-center">
							<v-btn outlined type="submit">{{ $lang('AUTH:UPDATE_PASSWORD:BUTTON_SUBMIT-TEXT') }}</v-btn>
							<v-btn text @click="$router.push({name:'home'})">{{ $lang('AUTH:UPDATE_PASSWORD:BUTTON_SECONDARY-TEXT') }}</v-btn>
						</div>
					</v-card-actions>
				</v-card>
			</form>
		</v-flex>
	</v-layout>
</template>

<script>
import { mapActions } from 'vuex'
export default {
	name: 'update-password',
	data(){
		return {
			user:{ password: null, password_new: null, password_new_confirm: null },
		}
	},
	computed: {
		errors: {
			get() { return this.$store.getters.getFormErrors }, set(_) {}
		}
	},
	methods:{
		...mapActions({
			updatePassword:'auth/updatePassword'
		}),
		submit(){
			this.updatePassword({user:this.user,context:this}).then((res)=>{
				this.$router.replace({name:'home'})
			}).catch(err => { })
		}
	}
}
</script>


